/* ----------------------------

Init Bootstrap Tooltips

---------------------------- */

$(document).ready(function(){

	$('[data-toggle="tooltip"]').tooltip();
		
});